'use strict';

//@see https://www.html5rocks.com/en/tutorials/eventsource/basics/
//and https://html.spec.whatwg.org/multipage/server-sent-events.html#server-sent-events
//and https://hpbn.co/server-sent-events-sse/

//note device check is in bootstrap.js

//*****************************************
// The exports can be generate with regex replace
// [\r\n]var
// \r\nexport var

//IMPORTANT: exported variables are always Read-Only!!!!!

//*****************************************

// import * as util from './util.js'

import {ebus} from './ebus';

let duringInit = false;
var eSource = null;
var eStreamOpen = false; //isSseConnecting
var retrySsePath, retryOpenCallback, retryClosedCallback, retryEdispatcher, retryUid = null;
var sseErrCount = 0;
// var hardExit = 'https://' + window.location.host + '/login';
let lastHeartbeat = 43038297554000; //year 3333

// export var hardExit = 'https://google.com/';

export function getLastHeartbeat() {
  return lastHeartbeat;
}

export function isOpen() {
  return eStreamOpen;
}

export function initSSE(ssePath, openCallback, closedCallback, eDispatcher, uid) {
  if (duringInit) {
    console.log('druginInit = true');
    setTimeout(() => {
      duringInit = false;
    }, 5000);
    return;
  }
  duringInit = true;
  // if (isSseConnecting) {
  //     return;
  // }
  // isSseConnecting = true;
  if (eStreamOpen) {
    openCallback(true);
    return;
  }
  retryUid = uid;
  retrySsePath = ssePath;
  // retryRestId = restId;
  retryOpenCallback = openCallback;
  retryClosedCallback = closedCallback;
  retryEdispatcher = eDispatcher;

  try {
    eSource = new EventSource(ssePath, {withCredentials: false});

    eSource.addEventListener('open', (e) => {
      eStreamOpen = true;
      console.log('SSE Open');
      // isSseConnecting = false;
      sseErrCount = 0;
      openCallback(false);
      duringInit = false;
    }, false);

    // EventSource lost connection or timed out
    eSource.addEventListener('error', (e) => {
      try {
        eStreamOpen = false;
        sseErrCount += 1;
        //if (e.readyState == EventSource.CLOSED) {
        console.log('SSE**** ERROR count ' + sseErrCount, e);
        // console.log('**** ERROR: ' + e);
      } catch (e) {
        //suck
      } finally {
        //Reinit
        // closeSSE();
        // setTimeout(() => {
        //     reinitSse();
        // }, 10000);
        if (sseErrCount > (8 * 100)) {
          // window.location.replace(hardExit);
        }
      }
      //}
    }, false);

    eSource.addEventListener('heartbeat', (e) => {
      console.log('.');
      lastHeartbeat = new Date().getTime();
    }, false);

    eSource.addEventListener('all', (e) => {
      //Security: verify e.origin in your message handler matches your app's origin:
      if (e.origin !== 'https://' + window.location.host) {//'http://example.com'
        // alert('Origin was not ' + host);
        return;
      }
      let data = JSON.parse(e.data);
      eDispatcher(data);
    }, false);

    //P2P messages for one uid
    console.log('P2P uid = ' + uid);
    eSource.addEventListener('user' + uid, (e) => {
      if (e.origin !== 'https://' + window.location.host) {//'http://example.com'
        // alert('Origin was not ' + host);
        return;
      }
      var data = JSON.parse(e.data);
      console.log('P2P message:', data);
      eDispatcher(data);
    }, false);
  } catch (e) {
    console.error('browser does not support eventsource');
  }

}//eof initSSE()

// initSSE();

export function reinitSse() {
  console.log('SSE try reinitSse');
  if (!eStreamOpen && retrySsePath) {
    console.log('SSE DO reinitSse');
    initSSE(retrySsePath, retryOpenCallback, retryClosedCallback, retryEdispatcher, retryUid);
  }
}

export function closeSSE(force) {
  console.log('SSE closeSSE');
  duringInit = false;
  if (retryClosedCallback) {
    console.log('SSE call retryClosedCallback()');
    retryClosedCallback();
  }
  console.log('SSE closeSSE eStreamOpen=' + eStreamOpen);
  if (!eStreamOpen) {
    return;
  }
  // setTimeout(()=>{
  //     reinitSse();
  // },8000);
  try {
    eStreamOpen = false;
    eSource.close();
  } catch (e) {
    console.log('SSE suck eSource.close() error: ', e);
    //suck
  }
}

//init visibility variables
let visible = true;
let visibilityChange;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
  // hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.mozHidden !== "undefined") {
  // hidden = "mozHidden";
  visibilityChange = "mozvisibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  // hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  // hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

const visibilityController = () => {
  if (document.visibilityState === 'visible') {
    visible = true;
    reinitSse();
    ebus.$emit('pageVisible');
  } else {
    visible = false;
    // closeSSE();
    ebus.$emit('pageHidden');
  }
  // if (document[hidden]) {
  //     visible = false;
  //     //don't exit the app when not visible
  //     closeSSE();
  //     ebus.$emit('pageHidden');
  // } else {
  //     visible = true;
  //     reinitSse();
  //     ebus.$emit('pageVisible');
  // }
};

export function isVisible() {
  return visible;
}

// console.log('??? add visibilityController');
document.addEventListener(visibilityChange, visibilityController);

window.addEventListener('pageshow', (event) => {
  // event.type
  // event.persisted
  ebus.$emit('pageshow');
}, false);

window.addEventListener('pageshide', (event) => {
  ebus.$emit('pageshide');
}, false);

window.addEventListener('freeze', (event) => {
  ebus.$emit('freeze');
}, false);

// window.addEventListener("offline", function () {
//   //testConnection(true);
//   console.log('window offline!');
// }, true);
